/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralUsersRepository = (options: GeneralRestApiOptions): Types.GeneralUsersRepository => ({
    async authorizeAction(params, requestOptions) {
        return options.request('/users/authorizeAction', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async authorizeDevice(params, requestOptions) {
        return options.request('/users/authorizeDevice', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async delete(params, requestOptions) {
        return options.request('/users/delete', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async deleteImage(params, requestOptions) {
        return options.request('/users/deleteImage', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getDeviceStatus(params, requestOptions) {
        return options.request('/users/getDeviceStatus', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getSignInInfo(params, requestOptions) {
        return options.request('/users/getSignInInfo', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getSsoInfo(params, requestOptions) {
        return options.request('/users/getSsoInfo', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getUserUpdateRequestsBySystem(params, requestOptions) {
        return options.request('/users/getUserUpdateRequestsBySystem', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async lock(params, requestOptions) {
        return options.request('/users/lock', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async resendDeviceAuthEmail(params, requestOptions) {
        return options.request('/users/resendDeviceAuthEmail', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async resetPassword(params, requestOptions) {
        return options.request('/users/resetPassword', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async sendMagicLink(params, requestOptions) {
        return options.request('/users/sendMagicLink', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async setPassword(params, requestOptions) {
        return options.request('/users/setPassword', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async signIn(params, requestOptions) {
        return options.request('/users/signIn', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async signOut(params, requestOptions) {
        return options.request('/users/signOut', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async signUp(params, requestOptions) {
        return options.request('/users/signUp', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async token(params, requestOptions) {
        return options.request('/users/token', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async unlock(params, requestOptions) {
        return options.request('/users/unlock', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async update(params, requestOptions) {
        return options.request('/users/update', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async updateImage(params, requestOptions) {
        return options.request('/users/updateImage', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async updatePassword(params, requestOptions) {
        return options.request('/users/updatePassword', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
